export default __webpack_public_path__ + "static/media/restic.449b9845.svg";